import { Component } from "@angular/core";
import { BaseComponent, IDatatableStateSaveableComponent } from "@impacgroup/angular-baselib";

@Component({
    selector: "app-tours-main",
    templateUrl: "./tours.main.component.html",
    standalone: false
})
export class ToursMainComponent extends BaseComponent implements IDatatableStateSaveableComponent {
    public listStateData: any;
}
